import { Injectable } from '@angular/core';
import { ClienteModel, EnderecoModel, TipoOsModel } from '../model';
import { AtivoModel } from './ativo.model';

@Injectable()
export class OrdemServicoModel {
    cliente: ClienteModel;
    ativo: AtivoModel;
    endereco: EnderecoModel;
    tipoOS: TipoOsModel;
    observacao: string;

    constructor() {
    }
}
